export default class RateArticle {
  constructor() {
    this._items = [];
    this._loading = false;
  }

  get(){
    const self = this;
    return new Promise((resolve, reject) => {
      self.set();
      resolve(self);
    });
  }
  set(data){
    this._items = data.map(item=>{
      return {
        id: item.Id,
        value: item.Id,
        name: item.Name,
        label: item.Name,
      }
    });
  }
  get loading() {
    return this._loading;
  }

  set loading(value) {
    this._loading = value;
  }

  get items() {
    return this._items;
  }
}